const rootArea = "/notices";

export const noticesGlob = () => ({
	read: `${rootArea}/*/read`,
	create: `${rootArea}/*/create`,
	update: `${rootArea}/*/update`,
	self: `${rootArea}/*`
});
